export default "__VITE_PUBLIC_ASSET__5f65ebd6__"